import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";

import "./i18n";
import "./index.css";
import { queryClient } from "@/lib/queryClient";
import { ThemeProvider } from "@/theme/ThemeProvider";
import { LayoutProvider } from "@/layout/LayoutProvider";
import { AuthProvider } from "@/auth/AuthProvider";
import { Toaster } from "@/components/ui/Toast";
import { RotatePrompt } from "@/components/layout/RotatePrompt";
import { App } from "@/app/App";
import { initWebVitals } from "@/lib/vitals";

// Start Core Web Vitals RUM collection (fire-and-forget, beacons to the backend).
initWebVitals();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ThemeProvider>
      <LayoutProvider>
        <QueryClientProvider client={queryClient}>
          <AuthProvider>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </AuthProvider>
          <Toaster />
          {/* Outside the router: a tablet held in portrait is in portrait on
              every route, including login, so this is not a per-screen concern. */}
          <RotatePrompt />
        </QueryClientProvider>
      </LayoutProvider>
    </ThemeProvider>
  </StrictMode>,
);
